export default {
    API: 'https://v1rvb.api.swingbe.de/',
    ADDRESS: 'https://overpass-api.de/api/interpreter?data=[out:json][timeout:60];relation(4189512);map_to_area;',
    AREA: '(area);out body center qt;',
};
